/* assets/ugx-review-blog.js */

(() => {
  "use strict";

  const SECTION_SELECTOR = "[data-urb-section]";
  const SEARCH_FORM_SELECTOR = "[data-urb-search-form]";
  const SEARCH_INPUT_SELECTOR = "[data-urb-search-input]";
  const CARD_ITEM_SELECTOR = "[data-urb-card-item]";
  const SEARCH_EMPTY_SELECTOR = "[data-urb-search-empty]";
  const PAGINATION_SELECTOR = "[data-urb-pagination]";

  const instances = new WeakMap();

  const normalizeText = (value) => {
    return String(value || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();
  };

  class UgxReviewBlogSearch {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector(SEARCH_FORM_SELECTOR);
      this.input = section.querySelector(SEARCH_INPUT_SELECTOR);
      this.cards = Array.from(section.querySelectorAll(CARD_ITEM_SELECTOR));
      this.empty = section.querySelector(SEARCH_EMPTY_SELECTOR);
      this.pagination = section.querySelector(PAGINATION_SELECTOR);

      this.onInput = this.onInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onReset = this.onReset.bind(this);

      this.init();
    }

    init() {
      if (!this.section || !this.form || !this.input) return;

      this.form.addEventListener("submit", this.onSubmit);
      this.input.addEventListener("input", this.onInput);
      this.input.addEventListener("search", this.onInput);

      this.filter();
    }

    destroy() {
      if (this.form) {
        this.form.removeEventListener("submit", this.onSubmit);
        this.form.removeEventListener("reset", this.onReset);
      }

      if (this.input) {
        this.input.removeEventListener("input", this.onInput);
        this.input.removeEventListener("search", this.onInput);
      }
    }

    onSubmit(event) {
      event.preventDefault();
      this.filter();
    }

    onInput() {
      this.filter();
    }

    onReset() {
      window.requestAnimationFrame(() => {
        this.filter();
      });
    }

    filter() {
      if (!this.input) return;

      const query = normalizeText(this.input.value);
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const haystack = normalizeText(card.getAttribute("data-urb-search-text"));

        const isMatch = query === "" || haystack.includes(query);

        if (isMatch) {
          card.hidden = false;
          visibleCount += 1;
        } else {
          card.hidden = true;
        }
      });

      if (this.empty) {
        this.empty.hidden = query === "" || visibleCount > 0;
      }

      if (this.pagination) {
        this.pagination.hidden = query !== "";
      }

      if (query === "") {
        this.section.removeAttribute("data-urb-searching");
      } else {
        this.section.setAttribute("data-urb-searching", "true");
      }
    }
  }

  const mount = (scope = document) => {
    const sections = Array.from(scope.querySelectorAll(SECTION_SELECTOR));

    sections.forEach((section) => {
      if (instances.has(section)) return;

      const instance = new UgxReviewBlogSearch(section);
      instances.set(section, instance);
    });
  };

  const unmount = (scope = document) => {
    const sections = Array.from(scope.querySelectorAll(SECTION_SELECTOR));

    sections.forEach((section) => {
      const instance = instances.get(section);

      if (instance) {
        instance.destroy();
      }

      instances.delete(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        mount(document);
      },
      { once: true }
    );
  } else {
    mount(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (!event || !event.target) return;
    mount(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (!event || !event.target) return;
    unmount(event.target);
  });

  document.addEventListener("shopify:section:select", (event) => {
    if (!event || !event.target) return;
    mount(event.target);
  });
})();